<template>
  <div>
    <div
      v-if="this.dataUnavailableTitle || this.dataUnavailableDescription"
      class="eretailer-unavailable hideInfo"
    >
      <h4>{{ this.dataUnavailableTitle }}</h4>
      <h5>{{ this.dataUnavailableDescription }}</h5>
    </div>
    <button class="button -primary buy-btn buy-btn-tag" @click="openBuyModal($event)">
      {{ this.dataButtontext }}
      <slot name="button" />
    </button>
    <div
      id="ccModal"
      class="cc-modal"
      :class="[hasButtons ? 'mb-sm' : '']"
      :data-variantid="currentVariantId"
    >
      <slot />
      <vch-modal
        :open="buyOnlineModalOpen"
        @closed="closeBuyModal"
        :busName="busNameBuyOnline"
        :data-variantid="currentVariantId"
        :modal-heading-aria-label="modalHeadingAriaLabel"
      >
        <carousel
          :per-page="1"
          :navigate-to="navigateToSlide"
          :mouse-drag="false"
          :centerMode="true"
          :navigationEnabled="true"
          :navigationPrevLabel="'<'"
          @pagination-click="moveToSecondSlide"
          @navigation-click="handleNavigationClick"
          :paginationEnabled="true"
          ref="carousel"
          :key="updateKeyValue"
        >
          <slide>
            <ccModalCountrySelectorVue
              :firstTitle="firstTitle"
              :firstDescription="firstDescription"
              :country="country"
              @countrySelect="getSelectedCountry"
              :productInfo="productInfo"
              id="country selector"
            >
            </ccModalCountrySelectorVue>
          </slide>
          <slide v-if="!websiteFlow">
            <ccModalProductDetailsVue
              v-if="selectedCountry"
              :secondTitle="secondTitle"
              :secondDescription="secondDescription"
              :selected-country="selectedCountry"
              :productInfo="productInfo"
              @variantSelect="getSelectedVariant"
              :modalOpen="modalOpen"
              id="product selector"
            >
            </ccModalProductDetailsVue>
          </slide>
          <slide>
            <ccModalOrderingOptionsVue
              v-if="showOrderOptionModal"
              :productInfo="productInfo"
              :thirdTitle="thirdTitle"
              :thirdDescription="thirdDescription"
              :pharmacyTitle="pharmacyTitle"
              :pharmacyDescription="pharmacyDescription"
              :commerceTitle="commerceTitle"
              :commerceDescription="commerceDescription"
              :clickCollectLabel="clickCollectLabel"
              :clickCollectTitle="clickCollectTitle"
              :clickCollectDescription="clickCollectDescription"
              :selected-country="selectedCountry"
              :currentVariantId="updatedVariantId"
              :pharmacyPageLink="pharmacyPageLink"
              :findPharmacyCTALabel="findPharmacyCTALabel"
              :clickandCollectWarningMessage="clickandCollectWarningMessage"
              :commerceWarningMessage="commerceWarningMessage"
              :iconHelperText="iconHelperText"
              id="order options"
              :key="updatedVariantId"
            ></ccModalOrderingOptionsVue>
          </slide>
        </carousel>
      </vch-modal>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { pushData } from 'Utils/datalayer';
import { busName as variantSelectorBus } from 'Directives/variant-selector/variant-selector';
import { Carousel, Slide } from 'vue-carousel';
import ccModalCountrySelectorVue from './cc-modal-country-selector/cc-modal-country-selector.vue';
import ccModalProductDetailsVue from './cc-modal-product-details/cc-modal-product-details.vue';
import ccModalOrderingOptionsVue from './cc-modal-ordering-options/cc-modal-ordering-options.vue';

export default {
  name: 'vch-cc-modal',
  components: {
    Carousel,
    Slide,
    ccModalCountrySelectorVue,
    ccModalProductDetailsVue,
    ccModalOrderingOptionsVue,
  },
  props: {
    dataButtontext: {
      type: String,
      required: true,
    },
    dataEan: {
      type: String,
      required: true,
    },
    dataApiurl: {
      type: String,
      required: true,
    },
    dataProductitemid: {
      type: String,
      required: true,
    },
    dataSubtitle: {
      type: String,
      required: true,
    },
    dataUnavailableTitle: {
      type: String,
      required: false,
    },
    dataUnavailableDescription: {
      type: String,
      required: false,
    },
    modalHeadingAriaLabel:{
      type: String,
      required: false,
      default: 'Modal heading',
    },
  },
  data() {
    return {      
      busNameBuyOnline: 'cc-modal-buy-modal',
      buyOnlineModalOpen: false,
      currentVariantId: null,
      websiteFlow: true,
      popUpData: null,
      country: null,
      productInfo: null,
      firstTitle: '',
      thirdTitle: '',
      thirdDescription: '',
      firstDescription: '',
      navigateToSlide: 0,
      selectedCountry: null,
      pharmacyTitle: '',
      pharmacyDescription: '',
      commerceTitle: '',
      commerceDescription: '',
      secondTitle: '',
      secondDescription: '',
      clickCollectLabel: '',
      clickCollectTitle: '',
      clickCollectDescription: '',
      findPharmacyCTALabel: '',
      pharmacyPageLink: '',
      clickandCollectWarningMessage: '',
      commerceWarningMessage: '',
      updatedVariantId: '',
      iconHelperText: '',
      modalOpen: true,
      onPageLoad: true,
      updateKeyValue: 0,
      showOrderOption :  false,
    };
  },
  computed: {
    hasButtons() {
      return this.$slots.default;
    },
    showOrderOptionModal() {
      return this.showOrderOption && this.selectedCountry && this.currentVariantId && this.updatedVariantId
    }
  },
  mounted() {   
    this.stickyBuyButtonPdp();

    this.currentVariantId = this.dataEan;
    eventBus.$on(`${variantSelectorBus}::selected`, this.updateVariantID);
    this.getProductData();
    this.getQueryParams();
    this.dataEventsOnLoad();
  },
  updated() {
    eventBus.$on(`${variantSelectorBus}::selected`, this.updateVariantID);
    eventBus.$on('buy-online-ecommerce-event', this.openBuyModal);   
    eventBus.$emit('buy-button-text', this.dataButtontext)
  },
  methods: {
    moveToSecondSlide(pgNbr) {  
      if (typeof pgNbr === 'number') {
        if (!pgNbr) this.showOrderOption = false;
        this.$refs.carousel.goToPage(pgNbr);
        this.updatedVariantId = this.currentVariantId;
        this.selectedCountry = this.country;
        this.$forceUpdate();
      } else {
        setTimeout(() => {
          if (this.selectedCountry == null) {
            this.$refs.carousel.goToPage(0);
          } else {
            if (this.websiteFlow) {
              this.updatedVariantId = this.currentVariantId;
            }
            this.$forceUpdate();
            this.$refs.carousel.goToPage(1);
          }
        }, 500);
      }
    },
    moveToThirdSlide() {
      setTimeout(() => {
        if (!this.websiteFlow) {
          if (this.updatedVariantId) {
            this.$forceUpdate();
            this.$refs.carousel.goToPage(2);
          } else {
            this.$refs.carousel.goToPage(1);
          }
        }
      }, 500);
    },
    closeBuyModal() {
      this.buyOnlineModalOpen = false;
      document.querySelectorAll('.cc-modal').forEach((node) => {
        if (node.style.display == '' || node.style.display == 'block') {
          node.style.display = 'none';
        }
      });
      this.stickyBuyButtonPdp();
      this.showOrderOption = false;
     },
    openBuyModal() {
      this.buyOnlineModalOpen = true;
      document.querySelectorAll('.cc-modal').forEach((node) => {
        if (node.style.display == 'none') {
          node.style.display = 'block';
        }
      });
      this.updateKeyValue = Math.floor(Math.random() * 100 + 1)
    },
    updateVariantID(variantEAN) {
      if (this.currentVariantId !== variantEAN) {
        this.dataEan = variantEAN;
        this.currentVariantId = variantEAN;
        this.websiteFlow = true;
        this.getProductData();
      }
    },
    eRetailerUnavailable() {
      if (this.onPageLoad) {
        const select = (selector) => document.querySelector(selector);
        const buyBtn = select(
          '.vch-pdp-grid__content .button.-primary.buy-btn'
        );
        const retailerInfo = select(
          '.vch-pdp-grid__content .eretailer-unavailable'
        );
        const channelAdvisorWrapper = select('.channel-advisor');
        if ((buyBtn || retailerInfo) && this.popUpData?.Products?.Varients) {
          for (const variant of this.popUpData.Products.Varients) {
            if (
              variant.Ean === this.dataEan &&
              (variant.Countrie[0].Shops === undefined ||
                variant.Countrie[0].Shops.length === 0)
            ) {
              buyBtn?.classList.add('hideBtn');
              retailerInfo?.classList.remove('hideInfo');
              !retailerInfo
                ? channelAdvisorWrapper?.classList.remove('mb-md')
                : channelAdvisorWrapper?.classList.add('mb-md');
            } else {
              retailerInfo?.classList.add('hideInfo');
              buyBtn?.classList.remove('hideBtn');
              !buyBtn
                ? channelAdvisorWrapper?.classList.remove('mb-md')
                : channelAdvisorWrapper?.classList.add('mb-md');
            }
          }
        } else {
          retailerInfo?.classList.remove('hideInfo');
          buyBtn?.classList.add('hideBtn');
          !retailerInfo
            ? channelAdvisorWrapper?.classList.remove('mb-md')
            : channelAdvisorWrapper?.classList.add('mb-md');
        }
        this.onPageLoad = false;
      }
    },
    getQueryParams() {
        const match = document.cookie.match(new RegExp('(^| )' + 'isLoggedIn' + '=([^;]+)'));   
        let result =  match ? match[2] : null;
        const callPopUpParam = result;
        callPopUpParam ? (this.websiteFlow = false) : (this.websiteFlow = true);
        if (!this.websiteFlow) {
          this.openBuyModal();
        }
    },
    getProductData() {
      fetch(
        `${this.dataApiurl}?ean=${this.dataEan}&productId=${this.dataProductitemid}&subTitle=${this.dataSubtitle}&websiteFlow=${this.websiteFlow}`
      )
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          this.popUpData = data;
          this.getData();
          !data.IsShowButton  && this.eRetailerUnavailable();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getData() {
      if (this.popUpData) {
        this.firstTitle = this.popUpData.FirstTitle;
        this.firstDescription = this.popUpData.FirstDescription;
        this.country = this.popUpData.Country;
        this.productInfo = this.popUpData.Products;
        this.thirdTitle = this.popUpData.ThirdTitle;
        this.thirdDescription = this.popUpData.ThirdDescription;
        this.pharmacyTitle = this.popUpData.PharmacyTitle;
        this.pharmacyDescription = this.popUpData.PharmacyDescription;
        this.commerceTitle = this.popUpData.CommerceTitle;
        this.commerceDescription = this.popUpData.CommerceDescription;
        this.secondTitle = this.popUpData.SecondTitle;
        this.secondDescription = this.popUpData.SecondDescription;
        this.clickCollectLabel = this.popUpData.ClickCollectLabel;
        this.clickCollectTitle = this.popUpData.ClickCollectTitle;
        this.clickCollectDescription = this.popUpData.ClickCollectDescription;
        this.findPharmacyCTALabel = this.popUpData.FindPharmacyCTALabel;
        this.pharmacyPageLink = this.popUpData.PharmacyPageLink;
        this.clickandCollectWarningMessage =
          this.popUpData.ClickandCollectWarningMessage;
        this.commerceWarningMessage = this.popUpData.CommerceWarningMessage;
        this.iconHelperText = this.popUpData.InfoIconLabel;
      }
    },
    getSelectedCountry(countryName) {
      this.showOrderOption = true;
      this.selectedCountry = countryName;
      this.moveToSecondSlide();
    },
    getSelectedVariant(selectedvariant) {
      this.currentVariantId = selectedvariant;
      this.updatedVariantId = selectedvariant;
      eventBus.$on(`${variantSelectorBus}::selected`, this.updateVariantID);
      this.moveToThirdSlide();
    },
    dataEventsOnLoad() {
      if (this.productInfo) {
        pushData({
          event: 'uaevent',
          event_name: 'buy_now',
          ecommerce: 'undefined',
          eventCategory: 'Ecommerce',
          eventAction: 'click to buy',
          eventLabel:
            this.productInfo.ProductName + '::' + this.currentVariantId,
          product_info:
            this.productInfo.ProductName + '::' + this.productInfo.ProductId
        });
      }
    },
    hideBuyButtonEretailerSticky() {
      const select = (selector) => document.querySelector(selector);
      const retailerInfo = select(
        '.vch-pdp-grid__content .eretailer-unavailable'
      );
      const buyBtn = select('.Product-Page .vch-sticky-bar .buy-btn');
      if (retailerInfo && !retailerInfo.classList.contains('hideInfo')) {
        buyBtn?.classList.add('hideBtn');
      } else {
        buyBtn?.classList.remove('hideBtn');
      }
    },
    stickyBuyButtonPdp(){
    const windowHeight = window.innerHeight;
    const stickyBar = document.getElementById('stickybarscroll');

    if (stickyBar) {
      stickyBar.style.display = 'none';

      window.addEventListener('scroll', () => {
        if (!this.buyOnlineModalOpen) {
          this.hideBuyButtonEretailerSticky();

          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const hasScrolledPast = scrollTop > windowHeight;

          stickyBar.style.display = hasScrolledPast ? 'block' : 'none';
        }
      });
    }

    },
    handleNavigationClick(direction) {      
      if (direction === 'backward') {
        this.showOrderOption = false;
      }
    }
  },
};
</script>
<style lang="scss" src="./cc-modal.scss"></style>
